module.exports = __webpack_public_path__ + "static/img/pc-01.55eb3c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/x3/pc-01.jpg
// module id = c3pr
// module chunks = 1